import React, { Component } from 'react';
import { Col, Label } from "reactstrap";
import AsyncSelect from 'react-select/async';
import { setTemaSeletor } from '../../../utils/formatar';

export default class SelectAsync extends Component {

    constructor(props) {
        super(props)
        this.loadOptionsCallback = this.props.loadOptionsCallback
    }

    loadOptions = value => new Promise(resolve => setTimeout(async () => { resolve(this.loadOptionsCallback(value)) }, 1000))

    render() {
        const { title, placeholder, onSelectItem } = this.props
        return (
            <Col
                className={this.props.className ? this.props.className : "mb-2"}
                xs={this.props.xs ? this.props.xs : ''}
                sm={this.props.sm ? this.props.sm : ''}
                md={this.props.md ? this.props.md : ''}
                lg={this.props.lg ? this.props.lg : ''}
                xl={this.props.xl ? this.props.xl : ''}
                style={{ flexDirection: "column" }}>
                <Label style={{ marginLeft: 0 }}>{title}</Label>
                <AsyncSelect
                    placeholder={placeholder || "Select"}
                    cacheOptions
                    className={"w-100 select-filtro"}
                    loadOptions={this.loadOptions}
                    defaultOptions
                    onChange={e => onSelectItem(e)}
                    isClearable={true}
                    theme={theme => setTemaSeletor(theme)}
                />
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/SelectAsync.js